import React from 'react';
import Banner from '../Banner.js';

const StartBanner = () => {
    return (
        <div className="hero relative" id="hero">
            <div className="absolute inset-0">
                {/* Full-width background video */}
                <Banner
                videoSrc="/videos/banner.mp4"
            />
                {/* Dark overlay for better text readability */}
                <div className="absolute inset-0 bg-black/40" />
            </div>

            {/* Centered text and button */}
            <div className="flex flex-col justify-center h-screen relative text-white text-center">
                <h1
                    className="text-5xl md:text-7xl font-semibold"
                    style={{ textShadow: '0 2px 12px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.9)' }}
                >
                    Ihr Weg zu mehr Effizienz und Unabhängigkeit
                </h1>
                <h5
                    className="text-3xl md:text-4xl font-medium"
                    style={{ textShadow: '0 2px 10px rgba(0,0,0,0.85), 0 1px 3px rgba(0,0,0,0.9)' }}
                >
                    Individuelle Energielösungen, die Kosten senken und nachhaltig begeistern
                </h5>
            </div>
        </div>
    );
};

export default StartBanner;
